/**
 * 配列内の指定した2つの要素を入れ替えた、新しい配列を返す（非破壊的）
 */
export function swap<T>(
  array: Array<T>,
  index1: number,
  index2: number,
): Array<T> {
  const updated = [...array];
  if (updated[index1] === undefined || updated[index2] === undefined) {
    return updated;
  }
  [updated[index1], updated[index2]] = [updated[index2], updated[index1]];
  return updated;
}
